
import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface StatCardContentProps {
  title: string;
  value: string;
  change: string;
  isPositiveChange: boolean;
  icon: React.ReactNode;
  iconBgClass: string;
}

const StatCardContent: React.FC<StatCardContentProps> = ({
  title,
  value,
  change,
  isPositiveChange,
  icon,
  iconBgClass,
}) => {
  return (
    <div className="p-5 flex justify-between items-start">
      <div className="space-y-2">
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{title}</p>
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white">{value}</h3>
        <p className={cn(
          "text-sm font-semibold flex items-center gap-1",
          isPositiveChange 
            ? "text-emerald-600 dark:text-emerald-400" 
            : "text-rose-600 dark:text-rose-400"
        )}>
          {isPositiveChange 
            ? <ArrowUp className="w-3 h-3 stroke-[3]" /> 
            : <ArrowDown className="w-3 h-3 stroke-[3]" />
          } 
          {change}
        </p>
      </div>
      <div className={cn(
        "p-3 rounded-full transition-transform duration-300 transform group-hover:scale-110",
        iconBgClass
      )}>
        {icon}
      </div>
    </div>
  );
};

export default StatCardContent;
